export default (state = {}, action) => {
  switch (action.type) {
    case 'GET_ADM_MENUS':
      return { ...state, admMenus: action.admMenus };
    case 'GET_ADM_MENUS_SELECT':
        return { ...state, admMenusSelect: action.admMenus };
    case 'GET_ADM_MENU':
      return { ...state, admMenu: action.admMenu };
    case 'GET_ADM_MENU_TREE':
        return { ...state, admMenuTree: action.admMenu };
    case 'GET_ADM_MENU_ROUTES':
          return { ...state, admMenuRoutes: action.admMenu };
    case 'GET_MENU_STATE':
      return { ...state, menuState: action.menuState };
    case 'SET_MENU_CURRENT_LEVEL':
        state['currentLevel'] = action.value;
        return { ...state };
    default:
      return state;
  }
};
